
import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/components/ui/use-toast";
import { Badge } from "@/components/ui/badge";
import {
  FileText,
  FilePlus,
  DollarSign,
  CheckCircle2,
  XCircle,
  Download,
  FileSignature,
  ChevronDown,
  Star,
  Loader2,
  RotateCcw,
} from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { contractDetails, TermAndCondition, useContractStore, acceptContract, dataValue, milestone } from "@/store/contractStore";
import { useUserStore } from "@/store/userStore";
import { CONTRACT_STATUS_KEY_WTIH_VALUE, MILESTONE_STATUS_KEY_WTIH_VALUE, MILESTONE_STATUS_WITH_KEY, Role } from "@/utils/constant";
import { FileUploadInput } from "@/components/FileUploadInput";
import ContractDialogWrapper from "./InitiateContract";
import Pagination from "@/components/ui/pagination-component";
import { authHeaders, Axios, socket } from "@/utils/axios";
import Milestone from "./Milestone";
import { API_END_POINTS } from "@/utils/routes";
import { ContractFilterText, ContractStatusKey, MilestoneStatusKey, TermAndConditionType } from "@/utils/enum";
import imagePlaceholder from "@/assets/images/image.png";
import { FreelancerProfile } from "@/store/jobApplyStore";
import Profile from "./Profile";
import { useNavigate } from "react-router-dom";
import CircularDotsLoader from "@/components/common/CircularLoader";
import RatingStars from "@/components/ui/ratingStars";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { capitalizeFirst, getImageUrl } from "@/lib/utils";

const Contracts = () => {
  const ref = useRef(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  const [contractFilter, setContractFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [submittedSearchTerm, setSubmittedSearchTerm] = useState("");
  const [acceptanceContractOpen, setAcceptanceContractOpen] = useState(false);
  const [acceptanceContractDetails, setAcceptanceContractDetails] = useState(null);
  const [rejectContractOpen, setRejectContractOpen] = useState(false);
  const [rejectContractDetails, setRejectContractDetails] = useState(null);
  const [rejectReasonText, setRejectReasonText] = useState(null);
  const [isMoreMilestoneShown, setMoreMilestoneShown] = useState(false);
  const [isMilestoneModalOpen, setMilestoneModalOpen] = useState(false);
  const [isCancelContract, setCancelContract] = useState(false);
  const [cancelContractData, setCancelContractData] = useState(null);
  const [openMilestoneDetails, setOpenMilestoneDetails] = useState(null);
  const [milestoneDialogOpenDetails, setMilestoneDialogOpenDetails] = useState(null);
  const [isReworkModalOpen, setIsReworkModalOpen] = useState(false);
  const [reworkMilestone, setReworkMilestone] = useState(null);
  const [reworkReasonText, setReworkReasonText] = useState(null);
  const {
    allContractsBasedOnFreelancerID,
    fetchAllContractsBasedOnFreelancerID,
    isLoading,
    error,
  } = useContractStore();
  const { user } = useUserStore();
  const [isHideUploadIcon, setIsHideUploadIcon] = useState(false);
  const [contractBinanceIdInput, setContractBinanceIdInput] = useState<string>("");
  const [savingContractBinanceId, setSavingContractBinanceId] = useState<boolean>(false);
  const [binanceVerificationOpen, setBinanceVerificationOpen] = useState<boolean>(false);
  const [pendingContractData, setPendingContractData] = useState<contractDetails | null>(null);
  const [originalBinanceId, setOriginalBinanceId] = useState<string>("");
  const [isBinanceIdVerified, setIsBinanceIdVerified] = useState<boolean>(false);
  const [isContractDialogOpen, setIsContractDialogOpen] = useState(false);
  const [isMilestoneDialogOpen, setIsMilestoneDialogOpen] = useState(false);
  const [updateContractData, setUpdateContractData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [isFreeLancerProfileOpen, setIsFreeLancerProfileOpen] = useState(false);
  const [freeLancerProfileOpenData, setfreeLancerProfileOpenData] = useState(null);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [feedbackContractData, setFeedbackContractData] = useState(null);
  const [rating, setRating] = useState(5);
  const [feedback, setFeedback] = useState("");

  const [activeContract, setActiveContract] = useState(null)

  const [showActiveContractModal, setShowActiveContractModal] = useState(false);
  const [qrCode, setQrCode] = useState<string | null>(null);

  const [loading, setLoading] = useState(false);

  const [merchantTradeNo, setMerchantTradeNo] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState('');
  const [paidAmount, setPaidAmount] = useState(0);

  const [showReleasePaymentModal, setShowReleasePaymentModal] = useState(false);
  const [contractSummary, setContractSummary] = useState(null);

  const [releaseMilstone, setReleaseMilstone] = useState(null);
  const [releaseRemark, setReleaseRemark] = useState<string>("");
  const [releaseTradeNo, setReleaseTradeNo] = useState<string>("");
  const [freelancerBinanceIdInput, setFreelancerBinanceIdInput] = useState<string>("");
  const [savingBinanceId, setSavingBinanceId] = useState<boolean>(false);
  const [showReleaseCompletionModal, setShowReleaseCompletionModal] = useState(false);
  const [refundContract, setRefundContract] = useState(false);
  const [refundContractData, setRefundContractData] = useState(null);
  const [refundContractSummary, setRefundContractSummary] = useState(null);
  const [enterpriseBinanceIdInput, setEnterpriseBinanceIdInput] = useState<string>("");
  const [savingEnterpriseBinanceId, setSavingEnterpriseBinanceId] = useState<boolean>(false);
  const [refundReason, setRefundReason] = useState<string>("");
  const [completionReleaseAmount, setCompletionReleaseAmount] = useState(0);
  const [completionContractId, setCompletionContractId] = useState<string | null>(null);

  const singleMilestoneReleaseDetails = contractSummary?.milestones?.find(
    (m: any) => m.milestoneId === releaseMilstone?._id
  );

  const contracts = allContractsBasedOnFreelancerID && allContractsBasedOnFreelancerID?.data ? allContractsBasedOnFreelancerID?.data : [];

  const [termAndCondition, setTermAndCondition] = useState<TermAndCondition[]>([]);
  const termAndConditionAccept: TermAndCondition[] = [
    {
      heading: "Signed Contract Form :",
      file: null,
      type: "file",
    },
    {
      heading: "Terms & Conditions",
      isAccepted: false,
      type: "checkbox",
    }
  ];
  const milestoneStatusWithKey = MILESTONE_STATUS_WITH_KEY;

  useEffect(() => {
    if (user?.userId && user?.accessToken) {
      ref.current = false;
      setCurrentPage(1);
      fetchAllContractsBasedOnFreelancerID(user.userId, user.accessToken, user.role,
        contractFilter === ContractFilterText.All ? "" : CONTRACT_STATUS_VALUE_WITH_KEY[contractFilter], submittedSearchTerm, currentPage);
      ref.current = true;
    };
    setTermAndCondition(termAndConditionAccept);
  }, [
    contractFilter,
    submittedSearchTerm]);

  const reloadContractData = () => {
    fetchAllContractsBasedOnFreelancerID(user.userId, user.accessToken, user.role,
      contractFilter === ContractFilterText.All ? "" : CONTRACT_STATUS_VALUE_WITH_KEY[contractFilter], submittedSearchTerm, currentPage);
  }

  useEffect(() => {
    setIsShowLoader(isLoading);
  }, [isLoading])

  // submit review modal
  useEffect(() => {
    const allContractData = allContractsBasedOnFreelancerID?.data;
    const findReviewAndRatingData = allContractData?.find(contractData => !contractData?.reviews?.enterpriseReview
      && CONTRACT_STATUS_KEY_WTIH_VALUE[contractData?.contract?.status] === ContractStatusKey.COMPLETED);
    if (findReviewAndRatingData && user.role === Role.FREELANCER) {
      setFeedbackContractData(findReviewAndRatingData);
      setIsFeedbackModalOpen(true);
    }
  }, [allContractsBasedOnFreelancerID])

  const loadNextPreAIRecommendedFreelancerJob = async (pageNumber: number) => {
    if (ref.current) {
      setCurrentPage(pageNumber);
      fetchAllContractsBasedOnFreelancerID(user.userId, user.accessToken, user.role, contractFilter === ContractFilterText.All ? "" : CONTRACT_STATUS_VALUE_WITH_KEY[contractFilter], submittedSearchTerm, pageNumber);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setSubmittedSearchTerm(searchTerm);
    }
  };

  const CONTRACT_STATUS_VALUE_WITH_KEY = Object.fromEntries(
    Object.entries(CONTRACT_STATUS_KEY_WTIH_VALUE).map(([k, v]) => [v, Number(k)])
  );

  const handleBlur = () => {
    if (searchTerm.trim()) {
      setSubmittedSearchTerm(searchTerm);
    }
  }

  // accept and close acceptance of contract modal
  const openAcceptanceContractModal = (open: boolean, acceptContractData: dataValue | null = null) => {
    if (open) {
      // First show Binance verification dialog
      setPendingContractData(acceptContractData?.contract);
      setBinanceVerificationOpen(true);
      // Initialize Binance ID from contract data
      const binanceId = acceptContractData?.freelancer?.binanceId || "";
      setContractBinanceIdInput(binanceId);
      setOriginalBinanceId(binanceId);
      setIsBinanceIdVerified(true); // If binanceId exists, consider it verified
    } else {
      setTermAndCondition([]);
      setAcceptanceContractDetails(null);
      setAcceptanceContractOpen(false);
      setContractBinanceIdInput("");
      setOriginalBinanceId("");
      setIsBinanceIdVerified(false);
    }
  }

  const closeAcceptanceContract = () => {
    setTermAndCondition([]);
    setAcceptanceContractDetails(null);
    setAcceptanceContractOpen(false);
    setContractBinanceIdInput("");
  }

  // Handle Continue button from Binance verification dialog
  const handleBinanceVerificationContinue = () => {
    setBinanceVerificationOpen(false);
    setTermAndCondition(termAndConditionAccept);
    setAcceptanceContractDetails(pendingContractData);
    setAcceptanceContractOpen(true);
  }

  // Handle closing Binance verification dialog
  const closeBinanceVerification = () => {
    setBinanceVerificationOpen(false);
    setPendingContractData(null);
    setContractBinanceIdInput("");
    setOriginalBinanceId("");
    setIsBinanceIdVerified(false);
  }

  // Handle Binance ID input change
  const handleBinanceIdChange = (value: string) => {
    setContractBinanceIdInput(value);
    // If the value is different from original, mark as unverified
    if (value !== originalBinanceId) {
      setIsBinanceIdVerified(false);
    } else {
      setIsBinanceIdVerified(true);
    }
  }

  // open and close milestone list modal
  const openMilestoneModal = (open: boolean, acceptContractData: dataValue | null = null) => {
    setOpenMilestoneDetails(acceptContractData);
    setMilestoneModalOpen(open);
  }

  const closeMilestoneContract = () => {
    setOpenMilestoneDetails(null);
    setMilestoneModalOpen(false);
  }

  // open and close cancel contract modal
  const openCancelContract = (open: boolean, cancelContractData: contractDetails | null = null) => {
    setCancelContractData(cancelContractData);
    setCancelContract(open);
  }

  const closeCancelContract = () => {
    setCancelContractData(null);
    setCancelContract(false);
  }

  const cancelContract = async () => {
    let reqCancelContractData = cancelContractData;
    reqCancelContractData.status = 5;
    try {
      setIsShowLoader(true);
      await Axios.put(
        `${API_END_POINTS.ACCEPT_CONTRACT}${cancelContractData?._id}`,
        reqCancelContractData,
        authHeaders(user.accessToken)
      );
      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: "The contract has been Cancelled.",
        variant: "destructive",
      });
    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: "Failed to cancel the contract. please try again",
        variant: "destructive",
      });
    }
    closeCancelContract();
  }

  const fetchQrCode = async () => {
    try {
      setLoading(true);
      const response = await Axios.post(
        `${API_END_POINTS.CREATE_ORDER}`,
        { contractId: activeContract?._id },
        authHeaders(user.accessToken)
      );

      const { qrCode, merchantTradeNo, transactionId } = response.data.data;

      // Set QR code and merchantTradeNo first
      setQrCode(qrCode);
      setMerchantTradeNo(merchantTradeNo);
      setTransactionId(transactionId);
      setPaymentStatus("PENDING");
      setPaidAmount(0);

      toast({
        title: "QR Code Generated",
        description: "Your QR code has been created successfully. Proceed with the payment.",
      });

    } catch (error) {
      console.error("Payment Error:", error);
      toast({
        title: "QR Code Failed",
        description: "We couldn’t generate your QR code. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Listen to payment notifications
    socket.on("payment_status", (notification) => {
      handlePaymentNotification(notification);
    });

    return () => {
      socket.off("payment_status"); // cleanup
    };
  }, []);

  const handlePaymentNotification = (notification) => {
    const { type, transactionId, amount, message } = notification;

    switch (type) {
      case "PAYMENT_SUCCESS":
        setPaymentStatus("COMPLETED");
        setPaidAmount(amount);
        toast({ title: "Success", description: message });
        break;

      case "PAYMENT_CANCELLED":
        setPaymentStatus("CANCELLED");
        toast({ title: "Cancelled", description: message });
        break;

      case "PAYMENT_FAILED":
        setPaymentStatus("FAILED");
        toast({ title: "Failed", description: message });
        break;

      case "PAYMENT_RELEASED":
        toast({ title: "Payment Released", description: message });
        // Refresh contract data to show updated payment status
        reloadContractData();
        break;

      case "PAYMENT_REFUNDED":
        toast({ title: "Payment Refunded", description: message });
        // Refresh contract data to show updated payment status
        reloadContractData();
        break;
    }
  };

  // Auto-fetch payment summary when release payment modal opens with a milestone selected
  useEffect(() => {
    if (showReleasePaymentModal && releaseMilstone?.contractId) {
      getContractPaymentSummary(releaseMilstone.contractId);
    }
  }, [showReleasePaymentModal, releaseMilstone]);

  // Reset remark when modal opens/closes or milestone changes
  useEffect(() => {
    if (showReleasePaymentModal) {
      setReleaseRemark("");
      setReleaseTradeNo(singleMilestoneReleaseDetails?.merchantTradeNo || merchantTradeNo || "");
      setFreelancerBinanceIdInput(contractSummary?.freelancer?.binanceId || "");
    } else {
      setReleaseRemark("");
      setReleaseTradeNo("");
      setFreelancerBinanceIdInput("");
    }
  }, [showReleasePaymentModal, releaseMilstone, contractSummary]);

  // When payment completes, close activation modal, refresh contracts, and reset state
  useEffect(() => {
    if (paymentStatus === "COMPLETED") {
      setShowActiveContractModal(false);
      reloadContractData();
      setQrCode(null);
      setMerchantTradeNo(null);
      setTransactionId(null);
    }
  }, [paymentStatus]);

  const cancelPayment = async () => {
    if (!transactionId) return;
    try {
      const res = await Axios.post(
        `${API_END_POINTS.CANCEL_PAYMENT}/${transactionId}/cancel`,
        {},
        authHeaders(user.accessToken)
      );

      if (res.data.success) {
        setPaymentStatus("CANCELLED");
        toast({ title: "Payment cancelled", description: res.data.message });
      }
    } catch (err) {
      console.error("Cancel payment error:", err);
      toast({ title: "Error", description: "Could not cancel payment." });
    }
  };

  const releaseSingleMilestonePayment = async (releaseMilstone) => {
    if (!releaseMilstone) return false;

    try {
      const releaseMerchantTradeNo = (singleMilestoneReleaseDetails?.merchantTradeNo || merchantTradeNo || `milestone${Date.now()}`).toString();
      const payload = {
        contractId: releaseMilstone.contractId,
        milestoneId: releaseMilstone._id,
        amount: releaseMilstone.amount,
        merchantTradeNo: releaseMerchantTradeNo,
        remark: releaseRemark?.trim() || undefined,
        receiverBinanceId: freelancerBinanceIdInput?.trim() || undefined
      };

      const res = await Axios.post(`${API_END_POINTS.RELEASE_PAYMENT}`, payload, authHeaders(user.accessToken));

      if (res.data.success) {
        toast({
          title: "Payment Released",
          description: `Milestone payment of ${releaseMilstone.amount} USDC released successfully.`
        });
        return true;
      }
    } catch (err) {
      console.error("Release milestone payment error:", err);
      toast({
        title: "Error",
        description: "Failed to release milestone payment. Please try again."
      });
      return false;
    }
  };


  // open update contract modal
  const openUpdateContractModal = (contractData: dataValue | null = null) => {
    let tempContractData = contractData;
    tempContractData.contract.milestones = contractData?.milestones;
    setUpdateContractData(tempContractData);
    setIsContractDialogOpen(true);
  }

  // open and close milestone modal
  const openAddUpdateMilestone = (contractData: dataValue | null = null, milestone: milestone | null = null) => {
    const newMilestone = {
      _id: "",
      contractId: contractData?.contract?._id,
      title: "",
      amount: "",
      status: "1",
      startDate: "",
      dueDate: "",
      description: "",
    }
    let tempContractData = contractData;
    tempContractData.contract.milestones = milestone ? [milestone] : [newMilestone];
    setMilestoneDialogOpenDetails(tempContractData);
    setIsMilestoneDialogOpen(true);
    closeMilestoneContract();
  }

  const closeAddUpdateMilestone = (open: boolean) => {
    setMilestoneDialogOpenDetails(null);
    setIsMilestoneDialogOpen(false);
  }


  const buildAcceptContractData = (termAndCondition: TermAndCondition[]): acceptContract => {
    return {
      termsAccepted: termAndCondition.find(tc => tc.type === TermAndConditionType.CheckBox && tc.heading.includes("Terms"))?.isAccepted || false,
      acceptedByFreelancer: true,
      ndaDocument: termAndCondition.find(tc => tc.type === TermAndConditionType.File)?.file || null,
    };
  };

  const disabledAcceptButton = (): boolean => {
    const termsAccepted =
      termAndCondition.find(tc => tc.type === TermAndConditionType.CheckBox && tc.heading.includes("Terms"))?.isAccepted;
    const uploadFile =
      termAndCondition.find(tc => tc.type === TermAndConditionType.File && tc.heading.includes("Contract"))?.file;
    return !(termsAccepted && uploadFile);
  };

  const handleAcceptContract = async (id: string | number) => {
    const data: acceptContract = buildAcceptContractData(termAndCondition);
    const formData = new FormData();
    formData.append("termsAccepted", String(data.termsAccepted));
    formData.append("acceptedByFreelancer", String(data.acceptedByFreelancer));
    if (data.ndaDocument) {
      formData.append("ndaDocument", data.ndaDocument);
    }
    try {
      setIsShowLoader(true);
      await Axios.patch(
        `${API_END_POINTS.ACCEPT_CONTRACT}${id}/accept`,
        formData,
        authHeaders(user?.accessToken)
      );
      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: "Contract Accepted",
        description: "The contract has been accepted and is now active.",
        variant: "success",
      });
    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: "Failed to accept the contract. please try again",
        variant: "destructive",
      });
    }
    closeAcceptanceContract();
  };

  // open and close reject contract modal
  const openRejectContractModal = (open: boolean, rejectContractData: contractDetails | number = null) => {
    setRejectContractDetails(rejectContractData);
    setRejectContractOpen(open);
  }

  const closeRejectContract = () => {
    setRejectContractDetails(null);
    setRejectContractOpen(false);
  }

  const handleRejectContract = async (id: string | number) => {
    const formData = new FormData();
    formData.append("termsAccepted", String(rejectReasonText));
    try {
      setIsShowLoader(true);
      await Axios.patch(
        `${API_END_POINTS.ACCEPT_CONTRACT}${id}/reject`,
        formData,
        authHeaders(user?.accessToken)
      );
      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: "The contract has been rejected.",
        variant: "destructive",
      });
    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: "Failed to reject the contract. please try again",
        variant: "destructive",
      });
    }
    closeRejectContract();
  };

  const handleDownloadContract = async (contractDetails: contractDetails | null) => {
    try {
      const res = await Axios.get(contractDetails?.attachment, {
        responseType: "blob",
      });
      const blob = res.data;
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", 'Contract Form');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
      toast({
        title: "The contract form has been downloaded.",
        variant: "destructive",
      });
    } catch (err: any) {
      toast({
        title: "Failed to download contract form. please try again",
        variant: "destructive",
      });
    }
  }

  const patchMilestoneStatusLabel = (milestoneStatus: string,) => {
    const status = milestoneStatusWithKey.find(data => data?.value === milestoneStatus?.toString())?.label;
    return status ? status : "In Progress";
  }

  const patchMilestoneButtonName = (milestone: milestone,) => {
    if (MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] === MilestoneStatusKey.INITIATED) {
      return 'Mark as In Progress';
    }
    if (MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] === MilestoneStatusKey.IN_PROGRESS) {
      return 'Mark as Submitted';
    }
    if (user.role === Role.ENTERPRISE) {
      if (MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] === MilestoneStatusKey.SUBMITTED) {
        return 'Mark as Reviewed';
      }
      if (MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] === MilestoneStatusKey.REVIEWED) {
        return 'Mark as Rejected';
      }
    } else {
      if (MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] === MilestoneStatusKey.NEEDS_REWORK) {
        return 'Mark as In Progress';
      }
    }
    return 'Mark as In Progress';
  }

  const handleCompleteMilestone = async (milestoneId: string | number, buttonTextName: string) => {
    const statusNumber = milestoneStatusWithKey?.find(data => buttonTextName?.includes(data?.label))?.value;
    const statusReq = {
      status: statusNumber ? Number(statusNumber) : 2,
    }
    try {
      setIsShowLoader(true);
      await Axios.put(
        `${API_END_POINTS.ADD_UPDATE_MILESTONE}/${milestoneId}`,
        statusReq,
        authHeaders(user?.accessToken)
      );
      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: "Milestone status has been updated.",
        variant: "destructive",
      });
    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: "Failed to update the milestone status. please try again",
        variant: "destructive",
      });
    }
    closeMilestoneContract();
  };

  const openMarkAsNeedsReWork = (milestoneId: milestone) => {
    setReworkMilestone(milestoneId);
    setIsReworkModalOpen(true);
    closeMilestoneContract();
  }

  const closeMarkAsNeedsReWork = () => {
    setReworkMilestone(null);
    setIsReworkModalOpen(false);
  }

  const markAsNeedsReWorkORReviewed = async (milestone: milestone, isRework: boolean = false) => {
    const reviewReq = {
      message: reworkReasonText,
      requireRework: isRework
    };
    try {
      setIsShowLoader(true);
      await Axios.post(
        `${API_END_POINTS.ADD_UPDATE_MILESTONE}/${milestone?._id}/approve`,
        reviewReq,
        authHeaders(user.accessToken)
      );
      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: "Milestone Status Updated!",
        description: "Milestone sent back for rework.",
        variant: "success",
      });

    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: "Failed to update the milestone status. please try again",
        variant: "destructive",
      });
    }
    closeMarkAsNeedsReWork();
  }

  const getContractPaymentSummary = async (contractId: string) => {
    try {
      const res = await Axios.get(`/api/transaction/contract/${contractId}/confirmation`, authHeaders(user.accessToken));
      setContractSummary(res.data?.data)
    } catch (error) {
      console.error("Error fetching contract payment summary:", error);
      throw error;
    }
  };

  const handleCompleteContractFlow = async (contract) => {
    try {
      const res = await Axios.get(`/api/transaction/contract/${contract?.contract?._id}/confirmation`, authHeaders(user.accessToken));
      const data = res.data?.data;
      const remaining = data?.paymentSummary?.remainingBalance || 0;
      if (remaining > 0) {
        setCompletionContractId(contract?.contract?._id);
        setCompletionReleaseAmount(remaining);
        setShowReleaseCompletionModal(true);
      } else {
        openFeedBackModal(true, contract);
      }
    } catch (e) {
      console.error('Error in complete contract flow:', e);
      toast({ title: 'Error', description: 'Unable to fetch contract payment info.' });
    }
  };

   const handleRefundPayment = async () => {
    try {
      const res = await Axios.post(`/api/transaction/refund`, {
        contractId: refundContractData._id,
        reason: refundReason.trim() || "Contract refund - remaining balance returned"
      }, authHeaders(user.accessToken));
      
      if (res.data?.success) {
        cancelContract()
        toast({ 
          title: 'Refund Processed', 
          description: `Refund of $${refundContractSummary?.paymentSummary?.remainingBalance || 0} has been processed successfully.` 
        });
        
        // Close modal and refresh data
        setRefundContract(false);
        setRefundContractData(null);
        setRefundContractSummary(null);
        setEnterpriseBinanceIdInput("");
        setRefundReason("");
        reloadContractData();
      }
    } catch (e) {
      console.error('Error processing refund:', e);
      toast({ title: 'Error', description: 'Failed to process refund. Please try again.' });
    }
  };

  const releaseContractCompletionPayment = async () => {
    if (!completionContractId || !completionReleaseAmount) return false;
    try {

      const releaseMerchantTradeNo = (singleMilestoneReleaseDetails?.merchantTradeNo || merchantTradeNo || `milestone${Date.now()}`).toString();
      const payload = {
        contractId: completionContractId,
        amount: completionReleaseAmount,
        merchantTradeNo: releaseMerchantTradeNo,
        remark: releaseRemark?.trim() || undefined,
        receiverBinanceId: freelancerBinanceIdInput?.trim() || undefined
      };


      const res = await Axios.post(`${API_END_POINTS.RELEASE_PAYMENT}`, payload, authHeaders(user.accessToken));
      if (res.data?.success) {
        toast({ title: 'Payment Released', description: `Released ${completionReleaseAmount} USDC successfully.` });
        setShowReleaseCompletionModal(false);
        setCompletionContractId(null);
        setCompletionReleaseAmount(0);
        return true;
      }
      return false;
    } catch (err) {
      console.error('Release completion payment error:', err);
      toast({ title: 'Error', description: 'Failed to release remaining balance.' });
      return false;
    }
  };

  const markAsApproved = async (milestone: milestone) => {
    try {
      setIsShowLoader(true);
      await Axios.post(
        `${API_END_POINTS.ADD_UPDATE_MILESTONE}/${milestone?._id}/approve`,
        {},
        authHeaders(user.accessToken)
      );

      getContractPaymentSummary(milestone.contractId);

      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: "Milestone has been approved.",
        variant: "destructive",
      });

    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: "Failed to approve the milestone. please try again",
        variant: "destructive",
      });
    }
    closeMilestoneContract();
  }

  const getContractStatusColor = (status: string) => {
    switch (status) {
      case "active":
        return "bg-emerald-100 text-emerald-800";
      case "completed":
        return "bg-blue-100 text-blue-800";
      case "draft":
        return "bg-gray-100 text-gray-800";
      case "pending":
        return "bg-amber-100 text-amber-800";
      case "in-progress":
        return "bg-amber-100 text-amber-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getMilestoneStatusColor = (status: string) => {
    switch (status) {
      case "submitted":
        return "bg-emerald-100 text-emerald-800";
      case "approved":
        return "bg-blue-100 text-blue-800";
      case "reviewed":
        return "bg-blue-100 text-blue-800";
      case "initiated":
        return "bg-gray-100 text-gray-800";
      case "in-progress":
        return "bg-amber-100 text-amber-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      case "needs-rework":
        return "bg-red-100 text-red-800";
      default:
        return "text-gray-800";
    }
  };

  const getTotalContractValue = () => {
    return allContractsBasedOnFreelancerID?.globalSummary?.totalValue;
  };

  const getActiveContractValue = () => {
    return allContractsBasedOnFreelancerID?.globalSummary?.activeValue;
  };

  const setUploadContractFile = (file: File) => {
    setIsHideUploadIcon(file ? true : false);
  }

  const uploadResumeAPI = async (file: File): Promise<any> => {
    if (file) {
      setIsHideUploadIcon(true);
    }
  }

  const navigateToFreelancePageDetails = (freelancer: FreelancerProfile) => {
    setIsFreeLancerProfileOpen(true);
    setfreeLancerProfileOpenData(freelancer);
  }

  const backToAIRecommFreelancer = () => {
    setIsFreeLancerProfileOpen(false);
    setfreeLancerProfileOpenData(null);
    navigate(`/contracts`);
  };

  const openFeedBackModal = (open: boolean, contractDetails: dataValue | null = null) => {
    setFeedbackContractData(null);
    setFeedbackContractData(contractDetails);
    setIsFeedbackModalOpen(open);
  }

  const submitFeedback = async (contractDetails: dataValue | null = null, rating, feedback) => {
    let reqCancelContractData = contractDetails?.contract;
    reqCancelContractData.status = 4;
    try {
      setIsShowLoader(true);
      // update contract with complete status
      if (user.role === Role.ENTERPRISE) {
        await Axios.put(
          `${API_END_POINTS.ACCEPT_CONTRACT}${reqCancelContractData?._id}`,
          reqCancelContractData,
          authHeaders(user.accessToken)
        );
      }
      //submit review rating for the enterprise to freelancer
      const reviewRatingReq = {
        rating: rating,
        review: feedback
      }
      const freelancerOrEnterpriseId = user.role === Role.ENTERPRISE ? contractDetails?.freelancer?._id : contractDetails?.enterprise?._id;
      const freelanceOrEnterpiseUrl = user.role === Role.ENTERPRISE ? 'freelancer' : 'enterprise';
      await Axios.post(
        `${API_END_POINTS.ACCEPT_CONTRACT}${freelanceOrEnterpiseUrl}/${freelancerOrEnterpriseId}/${reqCancelContractData?._id}/rating`,
        reviewRatingReq,
        authHeaders(user.accessToken)
      );
      setIsShowLoader(false);
      reloadContractData();
      toast({
        title: user.role === Role.ENTERPRISE ? "The review and rating have been submitted, and the contract has been completed." :
          "The review and rating have been submitted.",
        variant: "destructive",
      });
    } catch (err: any) {
      setIsShowLoader(false);
      toast({
        title: user.role === Role.ENTERPRISE ? "Failed to submit review and rating, and to complete the contract." :
          "Failed to submit review and rating.",
        variant: "destructive",
      });
    }
    setFeedbackContractData(null);
    setIsFeedbackModalOpen(false)
  }

  const updateApplicationStatusAfterInitiateContract = async () => {
    reloadContractData();
  }

  const filteredContracts = contracts;

  // Find the selected contract locally via contractId (fallback for quick UI reads)
  const releaseContract = React.useMemo(() => {
    const id = releaseMilstone?.contractId;
    if (!id) return null;
    return filteredContracts?.find((c: any) => c?.contract?._id === id) || null;
  }, [filteredContracts, releaseMilstone]);

  return (
    isFreeLancerProfileOpen ?
      <Profile backToAIRecommFreelancer={backToAIRecommFreelancer} isFromContracPage={true} newFreelancerData={freeLancerProfileOpenData} />
      : <div className="container mx-auto px-4 py-8 animate-fade-in">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gradient mb-2">Contracts & Agreements</h1>
            <p className="text-gray-600">Manage your freelance contracts and project agreements</p>
          </div>
        </div>

        {isShowLoader && <CircularDotsLoader className="absolute" text="Loading...." />}

        <div className="flex flex-col md:flex-row gap-4 mb-6">
          <div className="flex-1">
            <Input
              placeholder="Search contracts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
              onBlur={handleBlur}
              className="w-full"
            />
          </div>
          <Select value={contractFilter} onValueChange={setContractFilter}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Filter by status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Contracts</SelectItem>
              <SelectItem value="active">Active</SelectItem>
              <SelectItem value="pending">Pending</SelectItem>
              {user.role === Role.ENTERPRISE && <SelectItem value="cancelled">Cancelled</SelectItem>}
              <SelectItem value="completed">Completed</SelectItem>
              {user.role === Role.FREELANCER && <SelectItem value="rejected">Rejected</SelectItem>}
            </SelectContent>
          </Select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <Card className="glass-effect">
            <CardHeader className="pb-2">
              <CardTitle className="text-md font-medium">Total Contracts</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center">
                <FileText className="h-5 w-5 text-blue-500 mr-2" />
                <span className="text-2xl font-bold">{allContractsBasedOnFreelancerID?.globalSummary?.totalContracts}</span>
              </div>
              <p className="text-sm text-gray-500 mt-1">Active and completed</p>
            </CardContent>
          </Card>

          <Card className="glass-effect">
            <CardHeader className="pb-2">
              <CardTitle className="text-md font-medium">Active Contracts</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center">
                <CheckCircle2 className="h-5 w-5 text-emerald-500 mr-2" />
                <span className="text-2xl font-bold">
                  {allContractsBasedOnFreelancerID?.globalSummary?.activeContracts}
                </span>
              </div>
              <p className="text-sm text-gray-500 mt-1">In progress</p>
            </CardContent>
          </Card>

          <Card className="glass-effect">
            <CardHeader className="pb-2">
              <CardTitle className="text-md font-medium">Total Value</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center">
                <DollarSign className="h-5 w-5 text-amber-500 mr-2" />
                <span className="text-2xl font-bold">{getTotalContractValue()?.toLocaleString()}</span>
              </div>
              <p className="text-sm text-gray-500 mt-1">All contracts</p>
            </CardContent>
          </Card>

          <Card className="glass-effect">
            <CardHeader className="pb-2">
              <CardTitle className="text-md font-medium">Active Value</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center">
                <DollarSign className="h-5 w-5 text-purple-500 mr-2" />
                <span className="text-2xl font-bold">{getActiveContractValue()?.toLocaleString()}</span>
              </div>
              <p className="text-sm text-gray-500 mt-1">From active contracts</p>
            </CardContent>
          </Card>
        </div>

        <Tabs defaultValue="list" className="mb-6">
          <TabsList>
            <TabsTrigger value="list">List View</TabsTrigger>
            <TabsTrigger value="grid">Grid View</TabsTrigger>
          </TabsList>

          <TabsContent value="list" className="space-y-4">
            {filteredContracts?.length > 0 ? (
              filteredContracts.map((contract) => (
                <Card key={contract?.contract?._id} className="hover:shadow-md transition-all">
                  {user.role === Role.ENTERPRISE && <CardHeader className="pb-3">
                    <div className="flex justify-between items-start">
                      <div className="flex flex-row items-center gap-4">
                        <div className="relative w-16 h-16">
                          <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-200 to-emerald-200 opacity-50"></div>
                          <img
                            src={getImageUrl(contract?.freelancer?.profilePicture) || imagePlaceholder}
                            alt="Profile"
                            width={144}
                            height={144}
                            loading="eager"
                            className={`w-full h-full rounded-full bg-white p-1 shadow-md relative z-10`}
                          />
                          {/* <Badge size={"sm"}
                          className={`absolute bottom-0 left-2  ${getAvailabilityColor(contract?.freelancer?.availability ? "available" : "offline")} transition-colors cursor-pointer z-20 shadow-sm`}
                        >
                          {getAvailabilityText(contract?.freelancer?.availability ? "available" : "offline")}
                        </Badge> */}
                        </div>
                        <div>
                          <CardTitle onClick={() => navigateToFreelancePageDetails(contract?.freelancer)} className="text-xl underline cursor-pointer" >{contract?.freelancer?.designation}</CardTitle>
                          <CardDescription>Freelancer: <span className="underline cursor-pointer" onClick={() => navigateToFreelancePageDetails(contract?.freelancer)} >{capitalizeFirst(contract?.freelancer?.fullName).split(" ")[0]}</span></CardDescription>
                        </div>
                      </div>
                      <div className="flex flex-col gap-3 items-center">
                        <Badge className={getContractStatusColor(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status])}>
                          {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].charAt(0).toUpperCase() + CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].slice(1)}
                        </Badge>
                        {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.COMPLETED
                          && contract?.reviews?.enterpriseReview?._id &&
                          <div className="flex flex-row gap-1">
                            <Star
                              className={`h-4 w-4 transition-colors fill-yellow-400 text-yellow-400`}
                            /> <span className="text-xs" >{contract?.reviews?.enterpriseReview?.rating}/5</span>
                            <Popover>
                              <PopoverTrigger asChild>
                                <span className="text-xs cursor-pointer text-blue-600 hover:underline" >Review</span>
                              </PopoverTrigger>
                              <PopoverContent className="w-80 space-y-3">
                                <p className="text-sm text-gray-800">{contract?.reviews?.enterpriseReview?.review}</p>
                              </PopoverContent>
                            </Popover>
                          </div>}
                      </div>
                    </div>
                  </CardHeader>}
                  {user.role !== Role.ENTERPRISE && <CardHeader className="pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <CardTitle className="text-xl">{contract?.job?.title}</CardTitle>
                        <CardDescription>Client: {contract?.enterprise?.contactPerson?.name}</CardDescription>
                      </div>
                      <div className="flex flex-col gap-3 items-center">
                        <Badge className={getContractStatusColor(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status])}>
                          {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].charAt(0).toUpperCase() + CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].slice(1)}
                        </Badge>
                        {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.COMPLETED
                          && contract?.reviews?.freelancerReview?._id &&
                          <div className="flex flex-row gap-1">
                            <Star
                              className={`h-4 w-4 transition-colors fill-yellow-400 text-yellow-400`}
                            /> <span className="text-xs" >{contract?.reviews?.freelancerReview?.rating}/5</span>
                            <Popover>
                              <PopoverTrigger asChild>
                                <span className="text-xs cursor-pointer text-blue-600 hover:underline" >Review</span>
                              </PopoverTrigger>
                              <PopoverContent className="w-80 space-y-3">
                                <p className="text-sm text-gray-800">{contract?.reviews?.freelancerReview?.review}</p>
                              </PopoverContent>
                            </Popover>
                          </div>}
                      </div>
                    </div>
                  </CardHeader>}
                  <CardContent>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                      <div>
                        <p className="text-sm font-medium text-gray-500">Estimated Contract Value</p>
                        <p className="text-lg font-semibold">${contract.contract.budget.toLocaleString()}</p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-500">Duration</p>
                        <p className="text-base">
                          {new Date(contract?.contract?.startDate).toLocaleDateString()} - {new Date(contract?.contract?.endDate).toLocaleDateString()}
                        </p>
                      </div>
                    </div>

                    <div className="mb-4">
                      <p className="text-sm font-medium text-gray-500 mb-1">Project Scope</p>
                      <p className="text-sm">{contract?.job?.description}</p>
                    </div>

                    <div className="mb-4">
                      <p className="text-sm font-medium text-gray-500 mb-1">Terms</p>
                      <p className="text-sm">{contract?.contract?.terms}</p>
                    </div>

                    {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.PENDING &&
                      CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.CANCELLED &&
                      CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.REJECTED && contract?.milestones?.length > 0 && <div>
                        <p className="text-sm font-medium text-gray-500 mb-2">Milestones</p>
                        <div className="space-y-2">
                          {(isMoreMilestoneShown ? contract.milestones : contract.milestones.slice(0, 2)).map((milestone) => (
                            <div
                              key={milestone._id}
                              className="flex flex-col p-2 rounded-md bg-gray-50 border border-gray-100"
                            >
                              <div>
                                <div className="flex items-center p-2">
                                  <div className="flex flex-col items-start flex-1">
                                    <p className="font-medium ml-1">{milestone.title}</p>
                                    <p className="ml-1 text-sm text-gray-500">
                                      <span className="font-medium">Start on:</span> {new Date(milestone.startDate).toLocaleDateString()}
                                    </p>
                                    <p className="ml-1 text-sm text-gray-500">
                                      <span className="font-medium">Due on:</span> {new Date(milestone.dueDate).toLocaleDateString()}
                                    </p>
                                    {/* <p className="ml-1 text-sm text-gray-500">
                                    <span className="font-medium">Description:</span> {milestone.description}
                                  </p> */}
                                  </div>
                                  {/* <div className="flex flex-col items-center justify-center text-center">
                                  <p className="text-sm text-gray-500">
                                    <span className="font-medium">Start on:</span> {new Date(milestone.startDate).toLocaleDateString()}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    <span className="font-medium">Due on:</span> {new Date(milestone.dueDate).toLocaleDateString()}
                                  </p>
                                </div> */}
                                  <div className="flex-1 flex justify-end">
                                    <div className="flex flex-col items-center">
                                      <p className="font-semibold">${milestone.amount.toLocaleString()}</p>
                                      <div>
                                        <Badge className={getMilestoneStatusColor(MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status])}>
                                          {patchMilestoneStatusLabel(milestone.status)}
                                        </Badge>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ml-3 mt-1">
                                  <p className="text-sm font-medium text-gray-500">Description</p>
                                  <p className="text-sm">{milestone.description}</p>
                                </div>
                                {milestone?.reviews?.some(r => r?.requireRework) && (
                                  <div className="ml-3 mt-3">
                                    <p className="text-sm font-medium text-gray-500">Reworks</p>
                                    <ul className="ml-6 mt-1 list-disc">
                                      {milestone?.reviews?.map((rework) =>
                                        rework?.requireRework ? (
                                          <li key={rework._id} className="text-sm text-gray-600">
                                            {rework?.message}
                                          </li>
                                        ) : null
                                      )}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                          {contract.milestones.length > 2 && (
                            <>
                              {!isMoreMilestoneShown && <p className="text-sm text-center text-gray-500 cursor-pointer" onClick={() => setMoreMilestoneShown(true)}>
                                +{contract.milestones.length - 2} more milestones
                              </p>}
                              {isMoreMilestoneShown && <p className="text-sm text-center text-gray-500 cursor-pointer" onClick={() => setMoreMilestoneShown(false)}>
                                show less milestones
                              </p>}
                            </>
                          )}
                        </div>
                      </div>}
                    {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING && contract?.contract?.attachment &&
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDownloadContract(contract?.contract)}
                      >
                        <Download className="mr-2 h-4 w-4" />
                        {user.role === Role.ENTERPRISE ? "Attached Contract Form" : "Download Contract Form"}
                      </Button>}
                  </CardContent>
                  {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.REJECTED &&
                    CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.COMPLETED &&
                    CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.CANCELLED && (CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING || contract?.milestones?.length > 0 || user?.role === Role.ENTERPRISE) &&
                    <CardFooter className="flex justify-end gap-2 border-t pt-4">
                      {/* Reject contract  */}
                      {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING && user?.role !== Role.ENTERPRISE ? <Button
                        variant="outline"
                        size="sm"
                        onClick={() => openRejectContractModal(true, contract?.contract)}
                      >
                        <XCircle className="mr-1 h-4 w-4" />
                        Reject
                      </Button> : <div></div>}

                      {/* Active Contract */}
                      {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED) && user?.role === Role.ENTERPRISE &&
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            setShowActiveContractModal(true)
                            setActiveContract(contract?.contract)
                          }}>
                          <FileSignature className="mr-1 h-4 w-4" />
                          Active Contract
                        </Button>
                      }
                      {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS 
                      ) &&
                        user?.role === Role.ENTERPRISE &&
                        <Button
                          variant="outline"
                          size="sm" onClick={async () => {
                            try {
                              const res = await Axios.get(`/api/transaction/contract/${contract.contract._id}/confirmation`, authHeaders(user.accessToken));
                              setRefundContractSummary(res.data?.data);
                              setEnterpriseBinanceIdInput(res.data?.data?.enterprise?.binanceId || "");
                              setRefundContract(true);
                              setRefundContractData(contract.contract);
                            } catch (error) {
                              console.error("Error fetching contract payment summary:", error);
                              toast({ title: 'Error', description: 'Unable to fetch contract payment info.' });
                            }
                          }} >
                          <RotateCcw className="mr-1 h-4 w-4" />
                          Refund Payment
                        </Button>}

                      {/* Update Contract */}
                      {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING ||
                        CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS ||
                        CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED
                      ) && user?.role === Role.ENTERPRISE &&
                        <Button
                          variant="outline"
                          size="sm" onClick={() => openUpdateContractModal(contract)}>
                          <FileSignature className="mr-1 h-4 w-4" />
                          Update Contract
                        </Button>}

                      {/* Accept Contract */}
                      {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING && user?.role !== Role.ENTERPRISE &&
                        <Button
                          variant="outline"
                          size="sm" onClick={() => openAcceptanceContractModal(true, contract)} >
                          <CheckCircle2 className="mr-1 h-4 w-4" />
                          Accept Contract
                        </Button>}


                      {/* Update Milestones */}
                      {((CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED && user?.role === Role.ENTERPRISE) ||
                        CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                        contract?.milestones?.length >= 1 &&
                        <Button
                          variant="outline"
                          size="sm" onClick={() => openMilestoneModal(true, contract)} >
                          <FileSignature className="mr-1 h-4 w-4" />
                          Update Milestones
                        </Button>}

                      {/* Add Milestone */}
                      {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED ||
                        CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING ||
                        CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                        !contract?.milestones?.length && user?.role === Role.ENTERPRISE &&
                        <Button
                          variant="outline"
                          size="sm" onClick={() => openAddUpdateMilestone(contract)} >
                          <FilePlus className="mr-1 h-4 w-4" />
                          Add Milestone
                        </Button>}

                      {/* Cancel Contract   */}
                      {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING ||
                        CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                        user?.role === Role.ENTERPRISE &&
                        <Button
                          variant="outline"
                          size="sm" onClick={() => openCancelContract(true, contract?.contract)} >
                          <XCircle className="mr-1 h-4 w-4" />
                          Cancel Contract
                        </Button>}


                      {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS &&
                        contract?.milestones?.length > 0 &&
                        contract?.milestones.every((m) => m.paymentReleased === true) &&
                        user?.role === Role.ENTERPRISE) && (
                          <Button
                            variant="outline"
                            size="sm" onClick={() => handleCompleteContractFlow(contract)} >
                            <CheckCircle2 className="mr-1 h-4 w-4" />
                            Complete Contract
                          </Button>)}
                    </CardFooter>}
                </Card>
              ))
            ) : (
              <div className="text-center py-12 bg-gray-50 rounded-lg">
                <FileText className="h-12 w-12 text-gray-300 mx-auto mb-3" />
                <h3 className="text-lg font-medium text-gray-600">No Contracts Found</h3>
                <p className="text-gray-500">
                  {searchTerm ? "Try a different search term" : "Try a different contract status"}
                </p>
                {/* <Button 
                className="mt-4"
                onClick={() => setNewContractOpen(true)}
              >
                <FilePlus className="mr-2 h-4 w-4" />
                Create Contract
              </Button> */}
              </div>
            )}
          </TabsContent>

          {/* ----------------------------------- grid view -------------------------------------------- */}

          <TabsContent value="grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredContracts?.length > 0 ? (
              filteredContracts?.map((contract) => (
                <Card key={contract?.contract?._id} className="hover:shadow-md transition-all flex flex-col">
                  {user.role === Role.ENTERPRISE && <CardHeader className="pb-3">
                    <div className="flex justify-between items-start">
                      <div className="flex flex-row items-center gap-4">
                        <div className="relative w-16 h-16">
                          <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-200 to-emerald-200 opacity-50"></div>
                          <img
                            src={getImageUrl(contract?.freelancer?.profilePicture) || imagePlaceholder}
                            alt="Profile"
                            width={144}
                            height={144}
                            loading="eager"
                            className={`w-full h-full rounded-full bg-white p-1 shadow-md relative z-10`}
                          />
                          {/* <Badge size={"sm"}
                          className={`absolute bottom-0 left-2  ${getAvailabilityColor(contract?.freelancer?.availability ? "available" : "offline")} transition-colors cursor-pointer z-20 shadow-sm`}
                        >
                          {getAvailabilityText(contract?.freelancer?.availability ? "available" : "offline")}
                        </Badge> */}
                        </div>
                        <div>
                          <CardTitle onClick={() => navigateToFreelancePageDetails(contract?.freelancer)} className="text-base underline cursor-pointer" >{contract?.freelancer?.designation}</CardTitle>
                          <CardDescription className="text-sm">Freelancer: <span className="underline cursor-pointer" onClick={() => navigateToFreelancePageDetails(contract?.freelancer)} >{contract?.freelancer?.fullName}</span></CardDescription>
                        </div>
                      </div>
                      <div className="flex flex-col gap-3 items-center">
                        <Badge className={getContractStatusColor(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status])}>
                          {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].charAt(0).toUpperCase() + CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].slice(1)}
                        </Badge>
                        {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.COMPLETED
                          && contract?.reviews?.enterpriseReview?._id &&
                          <div className="flex flex-row gap-1">
                            <Star
                              className={`h-4 w-4 transition-colors fill-yellow-400 text-yellow-400`}
                            /> <span className="text-xs" >{contract?.reviews?.enterpriseReview?.rating}/5</span>
                            <Popover>
                              <PopoverTrigger asChild>
                                <span className="text-xs cursor-pointer text-blue-600 hover:underline" >Review</span>
                              </PopoverTrigger>
                              <PopoverContent className="w-80 space-y-3">
                                <p className="text-sm text-gray-800">{contract?.reviews?.enterpriseReview?.review}</p>
                              </PopoverContent>
                            </Popover>
                          </div>}
                      </div>
                    </div>
                  </CardHeader>}
                  {user.role !== Role.ENTERPRISE && <CardHeader className="pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <CardTitle className="text-base ">{contract?.job?.title}</CardTitle>
                        <CardDescription className="text-sm">Client: {contract?.enterprise?.contactPerson?.name}</CardDescription>
                      </div>
                      <div className="flex flex-col gap-3 items-center">
                        <Badge className={getContractStatusColor(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status])}>
                          {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].charAt(0).toUpperCase() + CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status].slice(1)}
                        </Badge>
                        {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.COMPLETED
                          && contract?.reviews?.freelancerReview?._id &&
                          <div className="flex flex-row gap-1">
                            <Star
                              className={`h-4 w-4 transition-colors fill-yellow-400 text-yellow-400`}
                            /> <span className="text-xs" >{contract?.reviews?.freelancerReview?.rating}/5</span>
                            <Popover>
                              <PopoverTrigger asChild>
                                <span className="text-xs cursor-pointer text-blue-600 hover:underline" >Review</span>
                              </PopoverTrigger>
                              <PopoverContent className="w-80 space-y-3">
                                <p className="text-sm text-gray-800">{contract?.reviews?.freelancerReview?.review}</p>
                              </PopoverContent>
                            </Popover>
                          </div>}
                      </div>
                    </div>
                  </CardHeader>}
                  <CardContent className="pb-2">
                    <div className="space-y-2 mb-3">
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">Estimated Value:</span>
                        <span className="font-medium">${contract?.contract?.budget.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">Start Date:</span>
                        <span>{new Date(contract?.contract?.startDate).toLocaleDateString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">End Date:</span>
                        <span>{new Date(contract?.contract?.endDate).toLocaleDateString()}</span>
                      </div>
                    </div>

                    {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.PENDING &&
                      CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.CANCELLED &&
                      CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.REJECTED && contract?.milestones?.length > 0 &&
                      <div>
                        <p className="text-sm font-medium text-gray-600 mb-1">Next Milestone:</p>
                        {contract.milestones.find(m => MILESTONE_STATUS_KEY_WTIH_VALUE[m?.status] !== MilestoneStatusKey.APPROVED) ? (
                          <div className="p-2 bg-gray-50 rounded-md border border-gray-100">
                            <p className="font-medium text-sm">
                              {contract.milestones.find(m => MILESTONE_STATUS_KEY_WTIH_VALUE[m?.status] !== MilestoneStatusKey.APPROVED)?.title}
                            </p>
                            <div className="flex justify-between text-sm">
                              <span className="text-gray-500">
                                Due: {new Date(contract.milestones.find(m => MILESTONE_STATUS_KEY_WTIH_VALUE[m?.status] !== MilestoneStatusKey.APPROVED)?.dueDate || "").toLocaleDateString()}
                              </span>
                              <span className="font-medium">
                                ${contract.milestones.find(m => MILESTONE_STATUS_KEY_WTIH_VALUE[m?.status] !== MilestoneStatusKey.APPROVED)?.amount.toLocaleString()}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <p className="text-sm mb-2 text-gray-500">All milestones completed</p>
                        )}
                      </div>}
                    {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING && contract?.contract?.attachment &&
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDownloadContract(contract?.contract)}
                      >
                        <Download className="mr-2 h-4 w-4" />
                        Download Contract Form
                      </Button>}
                  </CardContent>

                  {(
                    CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.REJECTED &&
                    CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.COMPLETED &&
                    CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] !== ContractStatusKey.CANCELLED &&
                    (CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING || contract?.milestones?.length > 0 || user?.role === Role.ENTERPRISE || (CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED && user?.role === Role.ENTERPRISE))
                  ) && (
                      <CardFooter className="flex justify-between border-t pt-3 mt-auto">

                        {/* Reject contract */}
                        {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING && user?.role !== Role.ENTERPRISE ? (
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => openRejectContractModal(true, contract?.contract)}
                          >
                            <XCircle className="mr-1 h-4 w-4" />
                            Reject
                          </Button>
                        ) : (
                          <div></div>
                        )}

                        <DropdownMenu>
                          <DropdownMenuTrigger asChild>
                            <Button variant="outline" size="sm">
                              Actions
                              <ChevronDown className="ml-1 h-3 w-3" />
                            </Button>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent>
                            {/**Active Contract */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED) && user?.role === Role.ENTERPRISE && (
                               <DropdownMenuItem onClick={() => openAcceptanceContractModal(true, contract)}>
                                <FileSignature className="mr-1 h-4 w-4" />
                                Active Contract
                              </DropdownMenuItem>
                            )}

                            {/* Update Contract */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING ||
                              CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                              user?.role === Role.ENTERPRISE && (
                                <DropdownMenuItem onClick={() => openUpdateContractModal(contract)}>
                                  <FileSignature className="mr-1 h-4 w-4" />
                                  Update Contract
                                </DropdownMenuItem>
                              )}

                            {/* Accept Contract */}
                            {CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING && user?.role !== Role.ENTERPRISE && (
                              <DropdownMenuItem onClick={() => openAcceptanceContractModal(true, contract)} >
                                <CheckCircle2 className="mr-1 h-4 w-4" />
                                Accept Contract
                              </DropdownMenuItem>
                            )}

                            {/* Update Milestones */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                              contract?.milestones?.length >= 1 && (
                                <DropdownMenuItem onClick={() => openMilestoneModal(true, contract)} >
                                  <FileSignature className="mr-1 h-4 w-4" />
                                  Update Milestones
                                </DropdownMenuItem>
                              )}

                            {/* Add Milestone */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.ACCEPTED ||
                              CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING ||
                              CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                              !contract?.milestones?.length && user?.role === Role.ENTERPRISE && (
                                <DropdownMenuItem onClick={() => openAddUpdateMilestone(contract)} >
                                  <FilePlus className="mr-1 h-4 w-4" />
                                  Add Milestone
                                </DropdownMenuItem>
                              )}

                            {/* Cancel Contract */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.PENDING ||
                              CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                              user?.role === Role.ENTERPRISE && (
                                <DropdownMenuItem onClick={() => openCancelContract(true, contract?.contract)} >
                                  <XCircle className="mr-1 h-4 w-4" />
                                  Cancel Contract
                                </DropdownMenuItem>
                              )}

                            {/* Refund Payment */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS) &&
                              user?.role === Role.ENTERPRISE && (
                                <DropdownMenuItem onClick={async () => {
                                  try {
                                    const res = await Axios.get(`/api/transaction/contract/${contract.contract._id}/confirmation`, authHeaders(user.accessToken));
                                    setRefundContractSummary(res.data?.data);
                                    setEnterpriseBinanceIdInput(res.data?.data?.enterprise?.binanceId || "");
                                    setRefundContract(true);
                                    setRefundContractData(contract.contract);
                                  } catch (error) {
                                    console.error("Error fetching contract payment summary:", error);
                                    toast({ title: 'Error', description: 'Unable to fetch contract payment info.' });
                                  }
                                }}>
                                  <RotateCcw className="mr-1 h-4 w-4" />
                                  Refund Payment
                                </DropdownMenuItem>
                              )}

                            {/* Complete Contract */}
                            {(CONTRACT_STATUS_KEY_WTIH_VALUE[contract?.contract?.status] === ContractStatusKey.IN_PROGRESS &&
                              ((contract?.milestones?.length > 0 &&
                                contract?.milestones?.every((m) => MILESTONE_STATUS_KEY_WTIH_VALUE[m.status] === MilestoneStatusKey.APPROVED)) ||
                                !contract?.milestones?.length)
                            ) &&
                              user?.role === Role.ENTERPRISE && (
                                <DropdownMenuItem onClick={() => openFeedBackModal(true, contract)} >
                                  <CheckCircle2 className="mr-1 h-4 w-4" />
                                  Complete Contract
                                </DropdownMenuItem>
                              )}

                          </DropdownMenuContent>
                        </DropdownMenu>
                      </CardFooter>
                    )}
                </Card>
              ))
            ) : (
              <div className="col-span-full text-center py-12 bg-gray-50 rounded-lg">
                <FileText className="h-12 w-12 text-gray-300 mx-auto mb-3" />
                <h3 className="text-lg font-medium text-gray-600">No Contracts Found</h3>
                <p className="text-gray-500">
                  {searchTerm ? "Try a different search term" : "Try a different contract status"}
                </p>
                {/* <Button 
                className="mt-4"
                onClick={() => setNewContractOpen(true)}
              >
                <FilePlus className="mr-2 h-4 w-4" />
                Create Contract
              </Button> */}
              </div>
            )}
          </TabsContent>

          {/* ---------------------------------- Binance ID Verification Dialog ------------------------------- */}
          <Dialog open={binanceVerificationOpen} onOpenChange={closeBinanceVerification}>
            <DialogContent className="sm:max-w-[500px]">
              <DialogHeader>
                <DialogTitle>Verify Your Binance ID</DialogTitle>
                <DialogDescription>
                  Please verify your Binance ID before accepting the contract. This is required for payment processing.
                </DialogDescription>
              </DialogHeader>
              <div className="mt-4">
                <div className="space-y-1">
                  <Label className="text-sm font-medium">Your Binance ID</Label>
                  <div className="flex gap-2">
                    <Input
                      placeholder="Enter Your Binance ID"
                      value={contractBinanceIdInput}
                      onChange={(e) => handleBinanceIdChange(e.target.value)}
                    />
                    <Button
                      variant="outline"
                      disabled={savingContractBinanceId || !contractBinanceIdInput?.trim()}
                      onClick={async () => {
                        try {
                          setSavingContractBinanceId(true);
                          await Axios.put(
                            `${API_END_POINTS.BINANCE_ID}`,
                            {
                              binanceId: contractBinanceIdInput?.trim(),
                              userId: user.userId,
                              role: Role.FREELANCER,
                            },
                            authHeaders(user.accessToken)
                          );

                          toast({
                            title: "Binance ID saved",
                            description: "Your Binance ID has been updated.",
                          });
                          setIsBinanceIdVerified(true);
                          setOriginalBinanceId(contractBinanceIdInput?.trim());
                        } catch (err) {
                          console.error("Save Binance ID error:", err);
                          toast({ title: "Error", description: "Failed to save Binance ID." });
                        } finally {
                          setSavingContractBinanceId(false);
                        }
                      }}
                    >
                      {savingContractBinanceId ? "Saving..." : "Save & Verify"}
                    </Button>
                  </div>
                </div>
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={closeBinanceVerification}>
                  Cancel
                </Button>
                <Button 
                  onClick={handleBinanceVerificationContinue}
                  disabled={!contractBinanceIdInput?.trim() || !isBinanceIdVerified}
                >
                  Continue
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>

          {/* ---------------------------------- Accept contract modal ------------------------------- */}

          {CONTRACT_STATUS_KEY_WTIH_VALUE[acceptanceContractDetails?.status] === ContractStatusKey.PENDING && <Dialog open={acceptanceContractOpen} onOpenChange={closeAcceptanceContract}>
            <DialogContent className="sm:max-w-[600px]">
              <DialogHeader>
                <DialogTitle>Accept Contract</DialogTitle>
              </DialogHeader>
              <div className="mt-4">
                {termAndCondition?.map((item, index) => (
                  <div>
                    {item.type === "file" && <div
                      key={index}
                      className="mb-4 p-4 border rounded-lg shadow-sm bg-white/50 backdrop-blur-sm min-h-20 flex items-center"
                    >
                      {item.type === "file" && (
                        <div className="grid grid-cols-6 items-center">
                          <div className=" text-start col-span-2">
                            <FileUploadInput
                              label="Signed Contract Form"
                              name="nda_url"
                              buttonText="Upload Signed Contract"
                              tooltipText="Upload your contract file (PDF/DOC, max 5MB)."
                              value={item?.file}
                              onChange={(file) => {
                                setTermAndCondition((prev) =>
                                  prev.map((tc, i) =>
                                    i === index ? { ...tc, file } : tc
                                  )
                                );
                                setUploadContractFile(file);
                              }}
                              onUpload={uploadResumeAPI}
                              toast={toast}
                              isHideLabelName={true}
                              isHideUploadIcon={isHideUploadIcon}
                            />
                          </div>
                        </div>
                      )}
                    </div>}
                    <div>
                      {item.type !== "file" && (
                        <div className="mb-6">
                          <h1 className="text-base font-semibold mb-1 text-gray-900">
                            {item.heading}
                          </h1>
                          <label
                            htmlFor="tandc"
                            className="block text-sm font-semibold text-gray-700 mb-2"
                          >
                            Please read the terms and conditions carefully before accepting:
                          </label>
                          <textarea
                            id="tandc"
                            readOnly
                            value={`By accepting this contract with Digika Enterprise, you agree to abide by the platform rules, the obligations of confidentiality, and the scope of services agreed upon with the client. All payments, milestones, and deliverables shall follow the enterprise contract policies. Violation of terms may result in suspension or termination of the contract. 

For full details, please review our Terms & Conditions Contract.`}
                            className="w-full h-40 p-4 border border-gray-300 rounded-lg bg-gray-50 text-sm text-gray-700 leading-relaxed resize-none mb-4"
                          />

                          {/* Checkbox + Link */}
                          <div className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              id={`check-${index}`}
                              className="w-4 h-4 accent-blue-600 cursor-pointer"
                              checked={item.isAccepted ?? false}
                              onChange={(e) => {
                                setTermAndCondition((prev) =>
                                  prev.map((tc, i) =>
                                    i === index ? { ...tc, isAccepted: e.target.checked } : tc
                                  )
                                );
                              }}
                            />
                            <label
                              htmlFor={`check-${index}`}
                              className="text-sm font-semibold text-gray-800 cursor-pointer"
                            >
                              I have read and agree to the{" "}
                              <a
                                href="/terms-and-condition-contract"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                Terms & Conditions
                              </a>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={() => closeAcceptanceContract()}>
                  Close
                </Button>
                <Button disabled={disabledAcceptButton()} onClick={() => handleAcceptContract(acceptanceContractDetails?._id)}>
                  Accept Contract
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>}

          {/* ----------------------------------- Reject contract modal -------------------------------- */}
          {CONTRACT_STATUS_KEY_WTIH_VALUE[rejectContractDetails?.status] === ContractStatusKey.PENDING &&
            <Dialog open={rejectContractOpen} onOpenChange={closeRejectContract}>
              <DialogContent className="sm:max-w-[600px] max-h-[90vh] flex flex-col">
                <DialogHeader>
                  <DialogTitle>Reject Contract</DialogTitle>
                  <DialogDescription>
                    Please provide a reason for rejecting this contract.
                  </DialogDescription>
                </DialogHeader>

                <div className="flex-1 mt-4">
                  <Label htmlFor="rejectreason" className="text-sm font-medium">
                    Reason for Rejection
                  </Label>
                  <Textarea
                    id="rejectreason"
                    placeholder="Please explain..."
                    value={rejectReasonText}
                    onChange={(e) => setRejectReasonText(e.target.value)}
                    className="mt-2 w-full min-h-[120px]"
                  />
                </div>

                <DialogFooter>
                  <Button variant="outline" onClick={closeRejectContract}>
                    Cancel
                  </Button>
                  <Button
                    disabled={!rejectReasonText}
                    onClick={() => handleRejectContract(rejectContractDetails?._id)}
                  >
                    Reject Contract
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          }

          {/* --------------------------------- milestone modal ------------------------------ */}
          {(CONTRACT_STATUS_KEY_WTIH_VALUE[openMilestoneDetails?.contract?.status] === ContractStatusKey.IN_PROGRESS ||
            (CONTRACT_STATUS_KEY_WTIH_VALUE[openMilestoneDetails?.contract?.status] === ContractStatusKey.ACCEPTED && user?.role === Role.ENTERPRISE)
          ) && (
              <Dialog open={isMilestoneModalOpen} onOpenChange={closeMilestoneContract}>
                <DialogContent className="sm:max-w-[700px] max-h-[90vh] pt-7 pb-7">
                  <DialogHeader>
                    <DialogTitle>Update Milestones Status</DialogTitle>
                    <DialogDescription>
                      Select a milestone to mark as completed
                    </DialogDescription>
                  </DialogHeader>
                  <div className="space-y-3 py-4">
                    {openMilestoneDetails.milestones.map((milestone) => (
                      <div
                        key={milestone._id}
                        className={`p-3 border rounded-md ${MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] === MilestoneStatusKey.APPROVED && user?.role === Role.FREELANCER
                          ? "bg-gray-50 opacity-70"
                          : "cursor-pointer hover:border-blue-300"
                          }`}
                      >
                        <div>
                          <div className="flex items-center p-2">
                            <div className="flex flex-col items-start flex-1">
                              <p className="font-medium ml-1">{milestone.title}</p>
                              <p className="ml-1 text-sm text-gray-500">
                                <span className="font-medium">Start on:</span> {new Date(milestone.startDate).toLocaleDateString()}
                              </p>
                              <p className="ml-1 text-sm text-gray-500">
                                <span className="font-medium">Due on:</span> {new Date(milestone.dueDate).toLocaleDateString()}
                              </p>
                              {/* <p className="ml-1 text-sm text-gray-500">
                                    <span className="font-medium">Description:</span> {milestone.description}
                                  </p> */}
                            </div>
                            {/* <div className="flex flex-col items-center justify-center text-center">
                                  <p className="text-sm text-gray-500">
                                    <span className="font-medium">Start on:</span> {new Date(milestone.startDate).toLocaleDateString()}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    <span className="font-medium">Due on:</span> {new Date(milestone.dueDate).toLocaleDateString()}
                                  </p>
                                </div> */}
                            <div className="flex-1 flex justify-end">
                              <div className="flex flex-col items-center">
                                <p className="font-semibold">${milestone.amount.toLocaleString()}</p>
                                <div>
                                  <Badge className={getMilestoneStatusColor(MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status])}>
                                    {patchMilestoneStatusLabel(milestone.status)}
                                  </Badge>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="ml-3 mt-1">
                            <p className="text-sm font-medium text-gray-500">Description</p>
                            <p className="text-sm">{milestone.description}</p>
                          </div>
                          {milestone?.reviews?.some(r => r?.requireRework) && (
                            <div className="ml-3 mt-3">
                              <p className="text-sm font-medium text-gray-500">Reworks</p>
                              <ul className="ml-6 mt-1 list-disc">
                                {milestone?.reviews?.map((rework) =>
                                  rework?.requireRework ? (
                                    <li key={rework._id} className="text-sm text-gray-600">
                                      {rework?.message}
                                    </li>
                                  ) : null
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                        {(
                          <div className="mt-3 flex justify-end gap-2">
                            {((MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.SUBMITTED &&
                              MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.REVIEWED &&
                              MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.REJECTED &&
                              MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.APPROVED && user?.role !== Role.ENTERPRISE) ||
                              (user?.role === Role.ENTERPRISE && MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.INITIATED &&
                                MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.IN_PROGRESS &&
                                MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.SUBMITTED &&
                                MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.NEEDS_REWORK &&
                                MILESTONE_STATUS_KEY_WTIH_VALUE[milestone.status] !== MilestoneStatusKey.APPROVED
                              )) &&
                              <Button
                                size="sm"
                                onClick={() => handleCompleteMilestone(milestone._id, patchMilestoneButtonName(milestone))}
                              >
                                {patchMilestoneButtonName(milestone)}
                              </Button>}
                            {(MILESTONE_STATUS_KEY_WTIH_VALUE[milestone?.status] === MilestoneStatusKey.SUBMITTED)
                              && user?.role === Role.ENTERPRISE && (
                                <Button
                                  size="sm"
                                  onClick={() => {
                                    markAsApproved(milestone)
                                  }}
                                >
                                  Mark as Approved
                                </Button>
                              )}

                            {(MILESTONE_STATUS_KEY_WTIH_VALUE[milestone?.status] === MilestoneStatusKey.APPROVED &&
                              user?.role === Role.ENTERPRISE &&
                              !milestone?.paymentReleased) && (
                                <Button
                                  size="sm"
                                  onClick={() => {
                                    setReleaseMilstone(milestone);
                                    setShowReleasePaymentModal(true);
                                  }}
                                >
                                  Release Payment
                                </Button>
                              )}

                            {MILESTONE_STATUS_KEY_WTIH_VALUE[milestone?.status] === MilestoneStatusKey.SUBMITTED && user?.role === Role.ENTERPRISE && <Button
                              size="sm"
                              onClick={() => openMarkAsNeedsReWork(milestone)}
                            >
                              Mark as Needs Rework
                            </Button>}
                            {milestone?.paymentReleased
                              ? (
                                <Badge className="text-green-800 bg-green-200" size="lg">
                                  Paid
                                </Badge>
                              )
                              : user?.role === Role.ENTERPRISE && (
                                <Button variant="outline" onClick={() => openAddUpdateMilestone(openMilestoneDetails, milestone)}>
                                  Edit
                                </Button>
                              )
                            }
                          </div>
                        )}
                      </div>
                    ))}
                    {user?.role === Role.ENTERPRISE && <Button variant="outline" onClick={() => openAddUpdateMilestone(openMilestoneDetails)}>
                      Add Milestone
                    </Button>}
                  </div>
                  <DialogFooter>
                    <Button variant="outline" onClick={() => closeMilestoneContract()}>
                      Close
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
            )}

          {/* ------------------------------- Cancel Contract -------------------------------- */}
          {(CONTRACT_STATUS_KEY_WTIH_VALUE[cancelContractData?.status] === ContractStatusKey.PENDING ||
            CONTRACT_STATUS_KEY_WTIH_VALUE[cancelContractData?.status] === ContractStatusKey.IN_PROGRESS
          ) && (
              <Dialog open={isCancelContract} onOpenChange={closeCancelContract}>
                <DialogContent className="w-[400px]">
                  <DialogHeader className="pt-5 pb-2">
                    <DialogTitle>Do you really want to cancel this contract?</DialogTitle>
                  </DialogHeader>
                  <DialogFooter>
                    <Button variant="outline" onClick={() => closeCancelContract()}>
                      No
                    </Button>
                    <Button variant="outline" onClick={() => cancelContract()}>
                      Yes
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
            )}

          {/* ------------------------------- Refund Payment -------------------------------- */}
          {refundContract && (
            <Dialog open={refundContract} onOpenChange={() => {
              setRefundContract(false)
              setRefundContractData(null)
              setRefundContractSummary(null)
              setEnterpriseBinanceIdInput("")
              setRefundReason("")
            }}>
              <DialogContent className="sm:max-w-[600px] flex flex-col gap-4 shadow-none">
                <DialogHeader>
                  <DialogTitle>Refund Contract Payment</DialogTitle>
                  <DialogDescription>
                    {refundContractSummary?.paymentSummary?.remainingBalance > 0 
                      ? `You are about to refund $${refundContractSummary.paymentSummary?.remainingBalance || 0} for this contract.`
                      : "You have 0 remaining balance to refund."
                    }
                  </DialogDescription>
                </DialogHeader>

                {refundContractSummary?.paymentSummary?.remainingBalance > 0 ? (
                  <>
                    <div className="space-y-1">
                      <Label className="text-sm font-medium">Your Binance ID</Label>
                      <div className="flex gap-2">
                        <Input
                          placeholder="Enter Your Binance ID"
                          value={enterpriseBinanceIdInput}
                          onChange={(e) => setEnterpriseBinanceIdInput(e.target.value)}
                        />

                        <Button
                          variant="outline"
                          disabled={savingEnterpriseBinanceId || !enterpriseBinanceIdInput?.trim()}
                          onClick={async () => {
                            try {
                              setSavingEnterpriseBinanceId(true);
                              await Axios.put(
                                `${API_END_POINTS.BINANCE_ID}`,
                                {
                                  binanceId: enterpriseBinanceIdInput?.trim(),
                                  userId: refundContractSummary?.enterprise?.id,
                                  role: Role.ENTERPRISE,
                                },
                                authHeaders(user.accessToken)
                              );

                              toast({
                                title: "Binance ID saved",
                                description: "Enterprise Binance ID updated.",
                              });

                              setRefundContractSummary((prev: any) =>
                                prev
                                  ? {
                                    ...prev,
                                    enterprise: {
                                      ...prev.enterprise,
                                      binanceId: enterpriseBinanceIdInput?.trim(),
                                    },
                                  }
                                  : prev
                              );
                            } catch (err) {
                              console.error("Save Enterprise Binance ID error:", err);
                              toast({ title: "Error", description: "Failed to save Enterprise Binance ID." });
                            } finally {
                              setSavingEnterpriseBinanceId(false);
                            }
                          }}
                        >
                          {savingEnterpriseBinanceId ? "Saving..." : "Save & Verify"}
                        </Button>
                      </div>
                    </div>

                    <div className="space-y-1">
                      <Label className="text-sm font-medium">Refund Reason (optional)</Label>
                      <Textarea
                        placeholder="Enter reason for refund"
                        value={refundReason}
                        onChange={(e) => setRefundReason(e.target.value)}
                        className="mt-1 w-full min-h-[80px]"
                      />
                    </div>
                  </>
                ) : (
                  <div className="rounded-md border bg-gray-50 p-4 text-center">
                    <p className="text-gray-600">No refundable amount available for this contract.</p>
                  </div>
                )}

                <DialogFooter className="flex justify-end gap-2">
                  <Button variant="outline" onClick={() => {
                    setRefundContract(false)
                    setRefundContractData(null)
                    setRefundContractSummary(null)
                    setEnterpriseBinanceIdInput("")
                    setRefundReason("")
                  }}>
                    Cancel
                  </Button>
                  {refundContractSummary.paymentSummary?.remainingBalance > 0 && <Button 
                    variant="outline"
                    onClick={() => handleRefundPayment()}
                  >
                    Refund
                  </Button>}
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}

          {/* ------------------------------ Update Contract -------------------------------------- */}
          <ContractDialogWrapper
            open={isContractDialogOpen}
            onOpenChange={setIsContractDialogOpen}
            updateApplicationStatusAfterInitiateContract={updateApplicationStatusAfterInitiateContract}
            freelancerApplicationID={updateContractData?.freelancer?._id}
            jobdetailsId={updateContractData?.job?._id}
            updateContractData={updateContractData?.contract}
          ></ContractDialogWrapper>

          {/* ------------------------ add edit milestone --------------------------  */}
          <Milestone
            open={isMilestoneDialogOpen}
            loadContractData={reloadContractData}
            onOpenChange={closeAddUpdateMilestone}
            updateContractData={milestoneDialogOpenDetails?.contract}>
          </Milestone>

          {/* -------------------------- Mark as Needs Rework ------------------------------- */}
          {<Dialog open={isReworkModalOpen} onOpenChange={closeMarkAsNeedsReWork}>
            <DialogContent className="sm:max-w-[600px] max-h-[90vh] flex flex-col">
              <DialogHeader>
                <DialogTitle>Request Rework</DialogTitle>
                <DialogDescription>
                  Provide a reason for requesting rework on this milestone.
                </DialogDescription>
              </DialogHeader>

              <div className="flex-1 mt-4">
                {/* <Label htmlFor="reworkreason" className="text-sm font-medium">
                Reason for rework
              </Label> */}
                <Textarea
                  id="reworkreason"
                  placeholder="Describe"
                  value={reworkReasonText}
                  onChange={(e) => setReworkReasonText(e.target.value)}
                  className="mt-3 w-full min-h-[150px]"
                />
              </div>

              <DialogFooter>
                <Button variant="outline" onClick={closeMarkAsNeedsReWork}>
                  Cancel
                </Button>
                <Button
                  disabled={!reworkReasonText}
                  onClick={() => markAsNeedsReWorkORReviewed(reworkMilestone, true)}
                >
                  Request Rework
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
          }
          {/* -------------------------- Active contract modal ------------------------------- */}
          {showActiveContractModal && (
            <Dialog open={showActiveContractModal} onOpenChange={(open) => {
              if (!open) {
                if (paymentStatus === "PENDING" && transactionId) {
                  cancelPayment();
                }
                setQrCode(null);
                setMerchantTradeNo(null);
                setTransactionId(null);
                setPaymentStatus("");
                setPaidAmount(0);
              }
              setShowActiveContractModal(open);
            }}>
              <DialogContent className="sm:max-w-[600px] max-h-[90vh] flex flex-col">
                {!qrCode || paymentStatus === "FAILED" ? (
                  <>
                    <DialogHeader>
                      <DialogTitle>Activate Contract</DialogTitle>
                      <DialogDescription>
                        {paymentStatus === "FAILED"
                          ? "Payment failed. You can regenerate a new QR code and try again."
                          : "By activating this contract, a secure payment QR code will be generated. Scan the QR code to proceed with payment."}
                      </DialogDescription>
                    </DialogHeader>

                    <DialogFooter>
                      <Button variant="outline" onClick={() => setShowActiveContractModal(false)}>
                        No, Go Back
                      </Button>
                      <Button
                        onClick={fetchQrCode}
                        disabled={loading}
                      >
                        {loading ? "Generating QR..." : paymentStatus === "FAILED" ? "Regenerate QR" : "Yes, Generate Payment QR"}
                      </Button>
                    </DialogFooter>
                  </>
                ) : (
                  <div className="flex flex-col items-center justify-center text-center">
                    <h2 className="text-lg font-semibold mb-2">Contract Activated</h2>
                    <p className="text-sm text-muted-foreground mb-4">
                      Your contract has been successfully activated.
                      <br />
                      Scan the QR code below to pay <span className="font-medium">{activeContract?.budget} USDC</span> into escrow.
                    </p>

                    <div className="flex flex-col items-center gap-3">
                      {qrCode ? (
                        <>
                          <img src={qrCode} alt="QR Code" className="mb-2" />
                          <p className="text-sm text-blue-600">Waiting for payment...</p>
                        </>
                      ) : (
                        <div className="flex items-center flex-col gap-2">
                          <Loader2 className="w-16 h-16 text-blue-500 animate-spin" />
                          <p className="text-sm text-blue-600">Generating QR code...</p>
                        </div>
                      )}
                    </div>

                    {paymentStatus === "COMPLETED" && (
                      <p className="text-green-600 text-lg font-semibold">Payment completed ✅</p>
                    )}

                    {paymentStatus === "FAILED" && (
                      <>
                        <p className="text-red-600 text-lg font-semibold mb-2">Payment failed ❌</p>
                        <Button onClick={fetchQrCode}>Regenerate QR</Button>
                      </>
                    )}

                    {paymentStatus === "CANCELLED" && (
                      <p className="text-yellow-600 text-lg font-semibold">Payment cancelled ⚠️</p>
                    )}
                  </div>
                )}
              </DialogContent>
            </Dialog>
          )}

          {/* ---------------------------- Release payment ------------------------------ */}
          {showReleasePaymentModal && (
            <Dialog
              open={showReleasePaymentModal}
              onOpenChange={(open) => {
                setShowReleasePaymentModal(open);
              }}
            >
              <DialogContent className="sm:max-w-[500px] flex flex-col gap-4 shadow-none">
                <DialogHeader>
                  <DialogTitle>Release Payment</DialogTitle>
                  <DialogDescription>
                    You are about to release a payment of <span className="font-medium"> {singleMilestoneReleaseDetails?.amount ?? releaseMilstone?.amount} USDC</span> for this milestone.
                  </DialogDescription>
                </DialogHeader>

                <div className="rounded-md border bg-gray-50 p-3 text-sm grid grid-cols-1 gap-3">
                  <div className="space-y-1">
                    <Label className="text-sm font-medium">Contract</Label>
                    <Input
                      readOnly
                      value={releaseContract?.job?.title || contractSummary?.contract?.title || activeContract?.terms || 'Contract'}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-sm font-medium">Milestone</Label>
                    <Input
                      readOnly
                      value={singleMilestoneReleaseDetails?.title || releaseMilstone?.title || 'Milestone'}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-sm font-medium">Amount</Label>
                    <Input
                      readOnly
                      value={`${(singleMilestoneReleaseDetails?.amount ?? releaseMilstone?.amount) || 0}`}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-sm font-medium">Currency</Label>
                    <Input readOnly value="USDC" />
                  </div>
                </div>

                <div className="space-y-1">
                  <Label className="text-sm font-medium">Freelancer Binance ID</Label>
                  <div className="flex gap-2">
                    <Input
                      placeholder="Enter Binance ID"
                      value={freelancerBinanceIdInput ?? contractSummary?.freelancer?.binanceId ?? ""}
                      onChange={(e) => setFreelancerBinanceIdInput(e.target.value)}
                    />

                    <Button
                      variant="outline"
                      disabled={savingBinanceId || !freelancerBinanceIdInput?.trim()}
                      onClick={async () => {
                        try {
                          setSavingBinanceId(true);
                          await Axios.put(
                            `${API_END_POINTS.BINANCE_ID}`,
                            {
                              binanceId: freelancerBinanceIdInput?.trim(),
                              userId: contractSummary?.freelancer?.id,
                              role: Role.FREELANCER,
                            },
                            authHeaders(user.accessToken)
                          );

                          toast({
                            title: "Binance ID saved",
                            description: "Freelancer Binance ID updated.",
                          });

                          setContractSummary((prev: any) =>
                            prev
                              ? {
                                ...prev,
                                freelancer: {
                                  ...prev.freelancer,
                                  binanceId: freelancerBinanceIdInput?.trim(),
                                },
                              }
                              : prev
                          );
                        } catch (err) {
                          console.error("Save Binance ID error:", err);
                          toast({ title: "Error", description: "Failed to save Binance ID." });
                        } finally {
                          setSavingBinanceId(false);
                        }
                      }}
                    >
                      {savingBinanceId ? "Saving..." : "Save & Verify"}
                    </Button>
                  </div>

                  {/* Show freelancer name as receiver */}
                  {contractSummary?.freelancer?.id && contracts.find(c => c.freelancer?.userId === contractSummary?.freelancer?.id)?.freelancer?.fullName && (
                    <p className="text-xs text-gray-500">
                      Receiver's Name: {contracts.find(c => c.freelancer?.userId === contractSummary?.freelancer?.id)?.freelancer?.fullName}
                    </p>
                  )}
                </div>

                <div className="space-y-1">
                  <Label className="text-sm font-medium">Remark (optional)</Label>
                  <Textarea
                    placeholder="Add a note for this payment"
                    value={releaseRemark}
                    onChange={(e) => setReleaseRemark(e.target.value)}
                    className="mt-1 w-full min-h-[80px]"
                  />
                </div>

                <DialogFooter className="flex justify-end gap-2">
                  <Button variant="outline" onClick={() => setShowReleasePaymentModal(false)}>
                    Cancel
                  </Button>
                  <Button
                    onClick={async () => {
                      const success = await releaseSingleMilestonePayment(releaseMilstone);
                      if (success) setShowReleasePaymentModal(false);
                    }}
                  >
                    Confirm & Release
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}

          {/* ------------------------- Release remaining balance (completion) ------------------------- */}
          {showReleaseCompletionModal && (
            <Dialog
              open={showReleaseCompletionModal}
              onOpenChange={(open) => setShowReleaseCompletionModal(open)}
            >
              <DialogContent className="sm:max-w-[500px] flex flex-col gap-4 shadow-none">
                <DialogHeader>
                  <DialogTitle>Release Remaining Balance</DialogTitle>
                  <DialogDescription>
                    You have a remaining balance of <span className="font-medium">{completionReleaseAmount} USDC</span> to complete this contract. Would you like to release it now?
                  </DialogDescription>
                </DialogHeader>

                <DialogFooter className="flex justify-end gap-2">
                  <Button variant="outline" onClick={() => setShowReleaseCompletionModal(false)}>
                    Not Now
                  </Button>
                  <Button
                    onClick={async () => {
                      const ok = await releaseContractCompletionPayment();
                      if (ok) {
                        setShowReleaseCompletionModal(false);
                        const contract = allContractsBasedOnFreelancerID?.data?.find(c => c?.contract?._id === completionContractId);
                        if (contract) {
                          openFeedBackModal(true, contract);
                        }
                      }
                    }}
                  >
                    Release & Continue
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}


          {/* ----------------------------  feedback and review ------------------------------ */}
          <Dialog open={isFeedbackModalOpen}>
            <DialogContent className="sm:max-w-[500px] max-h-[90vh] rounded-lg [&>button.absolute]:hidden">
              <DialogHeader>
                <DialogTitle>{user.role !== Role.ENTERPRISE ? "Rate & Review Enterprise" : "Rate & Review Freelancer"}</DialogTitle>
              </DialogHeader>
              <div className="flex flex-row justify-between p-2 gap-4 rounded-md bg-gray-100 border border-gray-100">
                <div className="flex flex-row items-center gap-3">
                  <div className="relative w-16 h-16">
                    <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-200 to-emerald-200 opacity-50"></div>
                    <img
                      src={user.role === Role.ENTERPRISE ? feedbackContractData?.enterprise?.avatarUrl || imagePlaceholder : feedbackContractData?.freelancer?.avatarUrl || imagePlaceholder}
                      alt="Profile"
                      width={144}
                      height={144}
                      loading="eager"
                      className={`w-full h-full rounded-full bg-white p-1 shadow-md relative z-10`}
                    />
                  </div>
                  <div>
                    <CardTitle className="text-lg" >{user.role === Role.ENTERPRISE ? feedbackContractData?.freelancer?.designation : feedbackContractData?.enterprise?.companyName}</CardTitle>
                    <CardDescription><span>{user.role === Role.ENTERPRISE ? feedbackContractData?.freelancer?.fullName : feedbackContractData?.enterprise?.contactPerson?.name}</span></CardDescription>
                  </div>
                </div>
                <div className="flex flex-col">
                  <Star
                    className={`h-4 w-4 transition-colors fill-yellow-400 text-yellow-400`}
                  /><span className="text-xs" >{user.role !== Role.ENTERPRISE ? feedbackContractData?.freelancer?.rating || 0 : feedbackContractData?.enterprise?.rating || 0}/5</span>
                </div>
              </div>
              {/* Rating */}
              <div className="mt-4 space-y-1">
                <Label className="text-sm font-medium">
                  {user.role !== Role.ENTERPRISE ? "How would you rate this enterprise" : "How would you rate this freelancer"}
                </Label>
                <RatingStars value={rating} onChange={setRating} />
              </div>

              {/* Feedback */}
              <div className="mt-4">
                <Label htmlFor="feedback" className="text-sm font-medium">
                  Share your experience
                </Label>
                <Textarea
                  id="feedback"
                  placeholder={`Tell others about your experience working with ${user.role === Role.ENTERPRISE ? feedbackContractData?.freelancer?.fullName : feedbackContractData?.enterprise?.companyName || 'Tech company'}...`}
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  className="mt-2 w-full min-h-[120px]"
                />
              </div>

              <DialogFooter className="mt-4 flex justify-between">
                <Button
                  className="bg-primary hover:bg-primary/90 text-white"
                  disabled={!rating || !feedback}
                  onClick={() => submitFeedback(feedbackContractData, rating, feedback)}
                >
                  Submit Review
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
          {allContractsBasedOnFreelancerID?.data?.length ?
            <Pagination
              totalPages={Math.ceil(allContractsBasedOnFreelancerID?.total / allContractsBasedOnFreelancerID?.limit)}
              onPageChange={loadNextPreAIRecommendedFreelancerJob}
              forcePage={(allContractsBasedOnFreelancerID.page || 1) - 1}
              className="mt-6"
            /> : null
          }
        </Tabs>
      </div>
  );
};

export default Contracts;
